import { BookingStatus } from "shared/types/enum";
import { BOOKING_STATUS_TONE, StatusTone } from "shared/utils";

// Booking-status -> badge tone, one source for every booking table, drawer
// and report (the map and its rationale live in shared/utils next to
// BOOKING_STATUS_LABELS). Unknown values fall back to grey rather than throw.
export const bookingStatusTone = (status: string): StatusTone =>
  BOOKING_STATUS_TONE[status as BookingStatus] ?? "neutral";
